module.exports = __webpack_public_path__ + "img/Products_Desktop_07.de4ae868.jpg";